import { z } from 'zod';

export const MyBenchCardHighlightsModalSchema = z.object({
  notes: z.string().max(500),
});

export type MyBenchCardHighlightsModalType = z.infer<
  typeof MyBenchCardHighlightsModalSchema
>;
